import createUserManager from './createUserManager'
import createRedirectUri from './createRedirectUri'
import { WebStorageStateStore } from 'oidc-client'
import { isMobile, isBrowser } from 'react-device-detect'
import yn from 'yn'

const isSilentRenewEnabled = () => {
  let enabled = false

  if (yn(process.env.REACT_APP_SILENT_RENEW)) {
    enabled =
      (isMobile && process.env.REACT_APP_SILENT_RENEW_PLATFORMS.includes('MOBILE')) ||
      (isBrowser && process.env.REACT_APP_SILENT_RENEW_PLATFORMS.includes('BROWSER'))
  }

  return enabled
}

const getResponseType = () => {
  if (isSilentRenewEnabled()) {
    return 'code'
  } else {
    return 'token id_token'
  }
}

const getClientId = () => {
  if (isMobile) {
    return process.env.REACT_APP_CLIENT_ID_MOBILE || process.env.REACT_APP_CLIENT_ID
  } else {
    return process.env.REACT_APP_CLIENT_ID
  }
}

const getUserStore = () => {
  if (isSilentRenewEnabled()) {
    return new WebStorageStateStore({ store: window.localStorage })
  } else {
    return new WebStorageStateStore({ store: window.sessionStorage })
  }
}

const config = {
  authority: `${process.env.REACT_APP_AUTH_ENDPOINT}/.well-known/openid-configuration`,
  scope: `profile email openid aws.cognito.signin.user.admin webpremios.campaigns/${process.env.REACT_APP_TENANT_ID}`,
  client_id: getClientId(),
  userStore: getUserStore(),
  response_type: getResponseType(),
  automaticSilentRenew: isSilentRenewEnabled(),
  //  accessTokenExpiringNotificationTime: 280,
  redirect_uri: createRedirectUri()
}

export default createUserManager(config)



// WEBPACK FOOTER //
// ./src/Auth/userManager.js